export const AVAILABLE_LOCALES = ['ru', 'uk'];



// WEBPACK FOOTER //
// ./src/shared/constants/locale.js